import React from 'react';
import img1 from '../../../Client work/24_feb_yeasin.png';
import img2 from '../../../Client work/Post-2.png';
import img3 from '../../../Client work/SLI - May 14.jpg';
import img4 from '../../../Client work/SH - May 10.png';
import img5 from '../../../Client work/Dekchi - June 22.jpg';
import img6 from '../../../Client work/Post-08_05-09-2022.png';
import img7 from '../../../Client work/Post-29_13-10-2022.png';
import img8 from '../../../Client work/Post-11.png';
import img9 from '../../../Client work/SLI - May 8.jpg';
import img10 from '../../../Client work/SH - July 31.png';
import img11 from '../../../Client work/Dekchi - July 30.png';
import img12 from '../../../Client work/Eden Apple Pie 12.09.22.jpg';
import img14 from '../../../Client work/Post-61_16-10-2022.png';
import img13 from '../../../Client work/Chilis - July 22.jpg';
import img15 from '../../../Client work/L-H_Post12_12june2023.png';
import img16 from '../../../Client work/SH - June 21.png';
import img17 from '../../../Client work/Santoor - June 10.png';
import img18 from '../../../Client work/Door_post25_04january2023.png';
import img19 from '../../../Client work/Chilis - July 5.jpg';
import img21 from '../../../Client work/L-H_Post22_10july2023.png';
import img22 from '../../../Client work/Post 6.png';
import img23 from '../../../Client work/SFD - July 13.jpg';
import img24 from '../../../Client work/Post-26_25-09-2022-GaziDoor_Rumi.png';
import img25 from '../../../Client work/Post-1.jpg';
import img26 from '../../../Client work/Post-02_04-04-2023.png';
import img27 from '../../../Client work/Santoor - June 22.jpg';
import img28 from '../../../Client work/SH - June 18.jpg';
import img29 from '../../../Client work/GC - March 26.jpg';
import img30 from '../../../Client work/Post-11_23-08-2022.png';
import img31 from '../../../Client work/Post 2.png';
import img32 from '../../../Client work/Post-03_04-04-2023.png';
import img33 from '../../../Client work/WhatsApp Image 2023-05-11 at 5.16.18 PM.jpeg';
import img34 from '../../../Client work/Shades-13-03-22-v2.png';
import img35 from '../../../Client work/GC V2 - Feb 21.jpg';
import img36 from '../../../Client work/RH Hygiene 28.3.23.jpg';
import img43 from '../../../Client work/2.2 Bokul.png';
import img45 from '../../../Client work/Peugeot_Post42_09july2023_02.png';
import img46 from '../../../Client work/10.2 Bokul.png';
import img49 from '../../../Client work/RH U-19 WC Womens 15.1.23.jpg';
import img50 from '../../../Client work/Asia-Cup-KV-Comics-16.png';
import './WorkAll.css';

const WorkAll = () => {
    return (
        <section className='mt-12'>
            <div className='grid grid-cols-2 lg:grid-cols-5'>
                <div>
                    <img src={img1} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img2} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img3} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img4} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img5} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img6} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img7} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img8} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img9} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img10} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img11} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img12} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img13} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img14} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img15} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img16} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img17} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img18} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img19} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img21} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img22} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img23} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img24} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img25} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img26} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img27} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img28} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img29} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img30} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img31} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img32} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img33} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img34} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img35} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img36} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img43} alt="" className='img-style' />
                </div>

                <div>
                    <img src={img45} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img46} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img49} alt="" className='img-style' />
                </div>
                <div>
                    <img src={img50} alt="" className='img-style' />
                </div>
            </div>
        </section>

    );
};

export default WorkAll;